import { useMutation } from "@tanstack/react-query";
import { graphierQLNextClient } from "utils";

import {
	GetMapByPasswordMutationQuery,
	GetMapByPasswordMutationQueryVariables,
} from "~map-view/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetMapByPasswordMutation($id: ID!, $password: String!) {
		getMapByPassword(id: $id, password: $password) {
			id
		}
	}
`;

export const useGetMapByPasswordMutation = () => {
	return useMutation({
		mutationFn: (variables: GetMapByPasswordMutationQueryVariables) =>
			graphierQLNextClient<
				GetMapByPasswordMutationQuery,
				GetMapByPasswordMutationQueryVariables
			>({
				query,
				variables,
				useKey: true,
			}).then((res) => res.getMapByPassword),
	});
};
